"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  width: 60%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & [class^='rc-slider-tooltip'] {
    display: none;
  }
`;
const IconWrapper = _styledComponents.default.div`
  position: relative;
  right: ${props => props.iconName !== 'plus' ? '15px' : undefined};
  left: ${props => props.iconName === 'plus' ? '20px' : undefined};
`;
const SliderWithIcon = _ref => {
  let {
    title,
    sliderLabel,
    minLabel,
    minValue,
    maxLabel,
    maxValue,
    value,
    onChangeHandle,
    onDecrease,
    onIncrease,
    increment
  } = _ref;
  const renderSliderLabels = (iconName, callbackFunc, title) => /*#__PURE__*/_react.default.createElement(IconWrapper, {
    iconName: iconName
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.IconButton, {
    shape: "circle",
    icon: {
      name: iconName
    },
    appearance: "alt2",
    size: 2,
    onClick: callbackFunc
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 1,
    appearance: "secondary"
  }, title)));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 7,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    justify: "center",
    size: 1,
    weight: 1
  }, title)), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.RangeSlider, {
    srLabel: {
      mainLabel: 'range-slider'
    },
    value: value,
    onChange: onChangeHandle,
    min: minValue,
    max: maxValue,
    appearance: "secondary",
    increment: maxValue - value < increment ? maxValue % value || 1 : increment,
    topLabels: {
      left: renderSliderLabels('minus', onDecrease, minLabel),
      center: sliderLabel,
      right: renderSliderLabels('plus', onIncrease, maxLabel)
    }
  })));
};
var _default = SliderWithIcon;
exports.default = _default;